import { createFileRoute } from "@tanstack/react-router";
import { AgentOpsPage } from "../features/agentops/AgentOpsPage";

// ?team=<id> opens that team; ?c=<channel> is the Tread the composer came from, so the
// list shows its teams first and a new team is attached to it; ?new=1 starts one.
export const Route = createFileRoute("/w/$ws/agentops")({
  component: () => {
    const { team, c, new: startNew } = Route.useSearch();
    return <AgentOpsPage openTeamId={team} channelId={c} startNew={startNew} />;
  },
  validateSearch: (s: Record<string, unknown>) => ({
    team: typeof s.team === "string" ? s.team : undefined,
    c: typeof s.c === "string" && /^[A-Za-z0-9_-]{1,40}$/.test(s.c) ? s.c : undefined,
    new: s.new === "1" || s.new === true || s.new === 1 ? true : undefined,
  }),
});
